// @ts-nocheck
import { Plugin } from '/tmp/build/src/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','default',],
});

export { plugin };
